/**
 * Created by tofael on 7/17/17.
 */
import React from 'react';
import {connect} from 'react-redux';
import api from '../utility/api';
import conf from '../utility/app-config';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';
import Profile from '../screens/profile';

const initialState = {
  name: '',
  user_name: '',
  email: '',
  phone: '',
  photo: null,
  address_line_1: '',
  address_line_2: '',
  postal_code: '',
  city: '',
  receive_review_email: false,
  fullscreen_image_url: '',
  imageViewerOpen: false,
  locked: false,
  alertDialogOpen: false,
  imagePreviewSrc: null,
  action: '',
  alertLabel: '',
  roleDialogOpen: false,
};

const previewImageUrl = (file, cb)=> {
  const fileReader = new FileReader();
  fileReader.readAsDataURL(file);
  fileReader.onload = function (event) {
    cb(event.target.result);
  };
};

class OperatorProfile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {...initialState};
  }

  resendLogin() {
    this.props.dispatch(asyncStart());
    this.setState({alertDialogOpen: false});
    api.resetPassword(this.state.user_id)
      .then(data => {
        this.props.dispatch(asyncEnd());
        this.setState({alertDialogOpen: false});
        this.props.dispatch(showFeedback({message: 'Password reset successful.'}));
      })
      .catch(error => {
        alert(error.message);
        this.props.dispatch(asyncEnd());
      });
  }

  showImage(url, event) {
    this.setState({
      ...this.state,
      fullscreen_image_url: url,
      imageViewerOpen: true
    });
  }

  closeImage() {
    this.setState({
      ...this.state,
      fullscreen_image_url: '',
      imageViewerOpen: false
    });
  }

  onPhotoSelect(e) {
    let file = e.target.files[0];

  previewImageUrl(file,(src)=>{
    this.setState({imagePreviewSrc: src});
  });

  this.setState({ photo: file });
}

  handleConfirmDialogClose() {
    this.setState({
      alertDialogOpen: false,
      action: '',
      alertLabel: ''
    });
  }

  handleConfirmDialogOpen(alertLabel, action) {
    this.setState({
      alertDialogOpen: true,
      action,
      alertLabel
    });
  };

  lockOperator() {
    this.props.dispatch(asyncStart());
    this.setState({alertDialogOpen: false});
    api.lockUser(this.state.user_id)
      .then(resp => {
        this.setState({locked: resp.locked})
        this.props.dispatch(showFeedback({message: 'User account locked.'}));
        this.props.dispatch(asyncEnd());
      })
      .catch(error => {
        alert(error.message);
        this.props.dispatch(asyncEnd());
      });

  };

  unlockOperator() {
    this.props.dispatch(asyncStart());
    this.setState({alertDialogOpen: false});
    api.unlockUser(this.state.user_id)
      .then(resp => {
        this.setState({locked: resp.locked});
        this.props.dispatch(showFeedback({message: 'User account unlocked.'}));
        this.props.dispatch(asyncEnd());
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
      });
  }

  componentDidMount() {
    this.props.dispatch(asyncStart());
    api.getUser(this.props.params.id)
      .then(resp => {
        this.props.dispatch(asyncEnd());
        let data = resp;
        this.setState({
          ...this.state,
          name: data.name,
          phone: data.phone,
          email: data.email,
          user_id: data.id,
          photo: data.photo,
          user_name: data.user_name,
          locked: data.locked,
          admin: data.admin,
          super_admin: data.super_admin,
          super_admin_original: data.super_admin,
          scheduler: data.scheduler,
          rmg: data.rmg,
          role: data.admin ? "admin" : "scheduler",
          address_line_1: data.location ? data.location.address_line_1 : null,
          address_line_2: data.location ? data.location.address_line_2 : null,
          postal_code: data.location ? data.location.postal_code : null,
          city: data.location ? data.location.city : null,
          receive_review_email: data.receive_review_email,
          imagePreviewSrc: data.photo ? conf.urls.doc_url + data.photo : './images/user.jpg'
        });
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      });
  }

  onToggle(){
    const userId = this.state.user_id;

    this.props.dispatch(asyncStart());
    api.toggleEmailReceiverFlag(userId)
      .then((user)=>{
        this.props.dispatch(asyncEnd());
        this.setState({receive_review_email: user.receive_review_email})
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      });
  }

  dispatch(action) {
    this.props.dispatch(action());
  }

  displayFeedBack(message) {
    this.props.dispatch(showFeedback({message: message}));
  }

  handleSubmit(e) {
    e.preventDefault();

    const {name, email, user_id: userId} = this.state;
    const data = {
      userId,
      name,
      email
    };

    this.dispatch(asyncStart);
    api.updateUserProfile(data)
      .then(user => {
        const photo = this.state.photo;
        if (photo && typeof photo === 'object') {
          let form_data = new FormData();
          form_data.append('photo', photo);
          form_data.append('userId', user.id);
          return api.updateAdminPhoto(form_data);
        }
        return data;
      })
      .then(user => {
        this.dispatch(asyncEnd);
        this.setState({
          name: user.name,
          email: user.email
        });
        this.props.dispatch(showFeedback({message: `Profile updated successfully.`}));
      })
      .catch(error => {
        this.dispatch(asyncEnd);
        this.props.dispatch(showFeedback({message: error.message}));
      })
  }

  updateRole(e){
    e.preventDefault();

    const {rmg, admin, super_admin, scheduler, user_id: userId} = this.state;
  
    if (!rmg && !admin && !super_admin && !scheduler) {
      this.props.dispatch(showFeedback({message: "Please select a role."}));
      return;
    } 

    const data = {
      rmg,
      admin,
      super_admin,
      scheduler,
      userId
    };

    api.updateRole(data)
      .then(user => {
        this.dispatch(asyncEnd);
        this.toggleRoleDialog();
        this.setState({
          rmg: user.rmg,
          admin: user.admin,
          super_admin: user.super_admin,
          scheduler: user.scheduler
        });
      })
      .then(data => {
        this.setState({roleDialogOpen: false});
        this.props.dispatch(showFeedback({message: "Role updated successfully."}));
        this.props.dispatch(asyncEnd());
      })
      .catch(error => {
        if (error.message === "Insufficient scope"){
          this.props.dispatch(showFeedback({message: "You are not authorized to make this change."}));
        } else {
          this.props.dispatch(showFeedback({message: error.message}));
        }
        this.props.dispatch(asyncEnd());
      });
  }
  selectRole() {
    const role = this.state.role;
     if (role === "admin") {
      this.setState({rmg:false});
      this.setState({admin:true});
      this.setState({scheduler:false});
    }
    else if(role === "scheduler") {
      this.setState({scheduler:true});
      this.setState({admin:false});
      this.setState({rmg:false});
    }
    else if(role === "rmg") {
      this.setState({rmg:true});
      this.setState({admin:false});
      this.setState({scheduler:false});
    }
  }

  toggleRoleDialog() {
    this.setState({roleDialogOpen: !this.state.roleDialogOpen});
   }

  handleChange(field, e) {
    this.setState({[field]: e.target.value});
  }

  onCheck(field, e, value) {
    this.setState({[field]: value});
  }

  handleSelect(field, e) {
    this.setState({[field]: e.target.value}, () => {
      this.selectRole()
    });
  }

  render() {
    const getHandleConfirmFunction = () => {
      const { action } = this.state;
      switch (action) {
        case 'lock' :
          return this.lockOperator.bind(this);
        case 'unlock' :
          return this.unlockOperator.bind(this);
        case 'reset-password' :
          return this.resendLogin.bind(this);
        default : return () => {
          throw new Error(`Unknown action: ${action}`);
        }
      }
    };

    const {isLoading} = this.props.application;

    return (
      <Profile
        title="User Profile"
        fields={this.state}
        locked={this.state.locked}
        onToggle={this.onToggle.bind(this)}
        resendLogin={this.resendLogin.bind(this)}
        showImage={this.showImage.bind(this)}
        showAlert={this.handleConfirmDialogOpen.bind(this)}
        isAdmin={true}
        isLoading={isLoading}
        onPhotoSelect={this.onPhotoSelect.bind(this)}
        roleDialogOpen={this.state.roleDialogOpen}
        toggleRoleDialog={this.toggleRoleDialog.bind(this)}
        updateRole={this.updateRole.bind(this)}
        closeImage={this.closeImage.bind(this)}
        imageViewerOpen={this.state.imageViewerOpen}
        imageUrl={this.state.fullscreen_image_url}
        alertDialogOpen={this.state.alertDialogOpen}
        alertText={this.state.alertLabel}
        onCheck={this.onCheck.bind(this)}
        handleSelect={this.handleSelect.bind(this)}
        handleChange={this.handleChange.bind(this)}
        handleSubmit={this.handleSubmit.bind(this)}
        imagePreviewSrc={this.state.imagePreviewSrc}
        handleConfirmDialogClose={this.handleConfirmDialogClose.bind(this)}
        getHandleConfirmFunction={getHandleConfirmFunction()}/>
    )

  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(OperatorProfile);



// WEBPACK FOOTER //
// ./src/containers/user-profile.js